import React, { useEffect, useRef, useState } from 'react'
import { ChevronLeft, ChevronRight } from '../../assets/icons'
import theme from '../../styled/theme'
import {
  CarouselNavButton,
  CarouselShell,
  CarouselTrack,
  CarouselViewport,
} from './styled'

const initialControls = {
  canPrevious: false,
  canNext: true,
  isScrollable: false,
}

const Carousel = ({
  children,
  cardSelector = '[data-carousel-card="true"]',
  gap = 16,
  previousLabel = 'Anterior',
  nextLabel = 'Siguiente',
}) => {
  const [controls, setControls] = useState(initialControls)
  const viewportRef = useRef(null)

  const updateControls = () => {
    const viewport = viewportRef.current

    if (!viewport) {
      return
    }

    const maxScrollLeft = Math.max(
      0,
      viewport.scrollWidth - viewport.clientWidth
    )
    const tolerance = 4

    setControls({
      canPrevious: viewport.scrollLeft > tolerance,
      canNext: viewport.scrollLeft < maxScrollLeft - tolerance,
      isScrollable: maxScrollLeft > tolerance,
    })
  }

  useEffect(() => {
    updateControls()
    window.addEventListener('resize', updateControls)

    return () => {
      window.removeEventListener('resize', updateControls)
    }
  }, [])

  const handleMove = direction => {
    const viewport = viewportRef.current

    if (!viewport) {
      return
    }

    const firstCard = viewport.querySelector(cardSelector)
    const cardWidth = firstCard
      ? firstCard.getBoundingClientRect().width
      : viewport.clientWidth
    const step = cardWidth + gap
    const maxScrollLeft = viewport.scrollWidth - viewport.clientWidth
    const tolerance = 4

    if (direction === 'next') {
      if (viewport.scrollLeft >= maxScrollLeft - tolerance) {
        return
      }

      viewport.scrollBy({ left: step, behavior: 'smooth' })
    }

    if (direction === 'previous') {
      if (viewport.scrollLeft <= tolerance) {
        return
      }

      viewport.scrollBy({ left: -step, behavior: 'smooth' })
    }

    window.setTimeout(updateControls, 250)
  }

  return (
    <CarouselShell>
      {controls.isScrollable && (
        <CarouselNavButton
          $position="left"
          aria-label={previousLabel}
          onClick={() => handleMove('previous')}
          type="button"
          disabled={!controls.canPrevious}
        >
          <ChevronLeft size={16} color={theme.colors.brand.blueOmint} />
        </CarouselNavButton>
      )}

      <CarouselViewport ref={viewportRef} onScroll={updateControls}>
        <CarouselTrack>{children}</CarouselTrack>
      </CarouselViewport>

      {controls.isScrollable && (
        <CarouselNavButton
          $position="right"
          aria-label={nextLabel}
          onClick={() => handleMove('next')}
          type="button"
          disabled={!controls.canNext}
        >
          <ChevronRight size={16} color={theme.colors.brand.blueOmint} />
        </CarouselNavButton>
      )}
    </CarouselShell>
  )
}

export default Carousel
